// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".select-amount__input[data-v-7697e961]{position:relative}.select-amount__input .v-input[data-v-7697e961]{padding-top:unset}", ""]);
// Exports
module.exports = exports;
